var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFirefox(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.1643 20.9465C58.8495 17.7827 56.1823 14.3667 54.0936 13.2868C55.5834 16.172 56.6172 19.2705 57.1583 22.4722L57.1637 22.523C53.7422 13.9927 47.9401 10.5533 43.2014 3.0638C42.9617 2.68511 42.722 2.30564 42.4885 1.90509C42.355 1.67632 42.2481 1.47018 42.1551 1.28045C41.9586 0.89985 41.8071 0.49762 41.7038 0.0819175C41.704 0.0627349 41.697 0.0441725 41.6844 0.0297715C41.6717 0.0153705 41.6542 0.00613873 41.6351 0.00383725C41.6165 -0.00127908 41.5968 -0.00127908 41.5781 0.00383725C41.5742 0.00383725 41.568 0.0108645 41.5633 0.0124261C41.5586 0.0139877 41.5485 0.0210149 41.5414 0.0241381L41.5531 0.00383725C33.952 4.45441 31.373 12.6934 31.1357 16.8145C28.1002 17.0232 25.198 18.1418 22.8076 20.0244C22.5583 19.8131 22.2976 19.6156 22.0268 19.4325C21.3373 17.019 21.3079 14.4647 21.9417 12.036C19.1503 13.3883 16.67 15.3052 14.6576 17.6656H14.6436C13.4443 16.1454 13.5286 11.1326 13.5973 10.0856C13.2425 10.2281 12.9038 10.408 12.5869 10.622C11.5282 11.3776 10.5385 12.2255 9.62926 13.1557C8.59322 14.2061 7.64696 15.3415 6.80042 16.5498V16.5545V16.549C4.85485 19.3073 3.4749 22.4236 2.74025 25.718L2.69964 25.9179C2.64265 26.1841 2.43729 27.5177 2.40216 27.8074C2.40216 27.8301 2.39747 27.8511 2.39513 27.8738C2.13023 29.2506 1.96609 30.6449 1.90401 32.0456V32.2018C1.91064 39.7789 4.75942 47.0779 9.88733 52.6562C15.0152 58.2345 22.0492 61.6862 29.599 62.3292C37.1488 62.9722 44.6651 60.7597 50.6625 56.1289C56.6599 51.4981 60.702 44.786 61.9899 37.3192C62.0406 36.9288 62.082 36.5423 62.1273 36.148C62.7506 30.9964 62.0758 25.7708 60.1643 20.9465ZM25.2859 44.6345C25.4272 44.7024 25.56 44.7758 25.7052 44.8406L25.7263 44.8539C25.5795 44.7836 25.4327 44.7105 25.2859 44.6345ZM57.1661 22.53V22.5011L57.1715 22.5331L57.1661 22.53Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1643 20.9465C58.8495 17.7827 56.1823 14.3667 54.0936 13.2869C55.5834 16.172 56.6172 19.2705 57.1583 22.4722V22.5011L57.1637 22.5331C59.4962 29.2078 59.1588 36.5256 56.2221 42.9573C52.7537 50.3992 44.3586 58.0268 31.2177 57.6559C17.0188 57.2538 4.51423 46.7177 2.17651 32.9178C1.75097 30.7417 2.17651 29.6384 2.39045 27.8699C2.0986 29.2436 1.93575 30.6416 1.90401 32.0456V32.2018C1.91064 39.7789 4.75942 47.0779 9.88733 52.6562C15.0152 58.2345 22.0492 61.6862 29.599 62.3292C37.1488 62.9722 44.6651 60.7597 50.6625 56.1289C56.6599 51.4981 60.702 44.786 61.9899 37.3192C62.0406 36.9288 62.082 36.5423 62.1273 36.148C62.7506 30.9964 62.0758 25.7708 60.1643 20.9465Z",
    fill: "url(#paint1_radial)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1643 20.9465C58.8495 17.7827 56.1823 14.3667 54.0936 13.2869C55.5834 16.172 56.6172 19.2705 57.1583 22.4722V22.5011L57.1637 22.5331C59.4962 29.2078 59.1588 36.5256 56.2221 42.9573C52.7537 50.3992 44.3586 58.0268 31.2177 57.6559C17.0188 57.2538 4.51423 46.7177 2.17651 32.9178C1.75097 30.7417 2.17651 29.6384 2.39045 27.8699C2.0986 29.2436 1.93575 30.6416 1.90401 32.0456V32.2018C1.91064 39.7789 4.75942 47.0779 9.88733 52.6562C15.0152 58.2345 22.0492 61.6862 29.599 62.3292C37.1488 62.9722 44.6651 60.7597 50.6625 56.1289C56.6599 51.4981 60.702 44.786 61.9899 37.3192C62.0406 36.9288 62.082 36.5423 62.1273 36.148C62.7506 30.9964 62.0758 25.7708 60.1643 20.9465Z",
    fill: "url(#paint2_radial)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4587 24.5039C45.5243 24.55 45.5852 24.5961 45.6469 24.6421C44.8867 23.2942 43.9405 22.0601 42.836 20.9763C33.4305 11.5691 40.371 0.579357 41.5414 0.0210839L41.5531 0.00390625C33.952 4.45448 31.373 12.6935 31.1357 16.8146C31.4886 16.7904 31.8384 16.7607 32.1991 16.7607C34.8962 16.7656 37.5438 17.4847 39.8728 18.8448C42.2018 20.2048 44.1291 22.1574 45.4587 24.5039Z",
    fill: "url(#paint3_radial)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2187 26.3826C32.1687 27.1353 29.5093 29.7314 28.5793 29.7314C19.9741 29.7314 18.5773 34.937 18.5773 34.937C18.9583 39.3205 22.0128 42.9309 25.7052 44.8407C25.8739 44.9282 26.0449 45.007 26.2159 45.0843C26.512 45.2155 26.8082 45.3368 27.1044 45.4482C28.3716 45.8967 29.6989 46.1528 31.042 46.2079C46.1247 46.9153 49.0465 28.1714 38.1621 22.7323C40.7298 22.3982 43.3301 23.0296 45.4587 24.504C44.1291 22.1574 42.2018 20.2049 39.8728 18.8448C37.5438 17.4847 34.8962 16.7657 32.1991 16.7607C31.84 16.7607 31.4886 16.7904 31.1357 16.8146C28.1002 17.0233 25.198 18.1419 22.8076 20.0245C23.2691 20.4149 23.7899 20.9365 24.8869 22.0179C26.9404 24.0409 32.2069 26.1366 32.2187 26.3826Z",
    fill: "url(#paint4_radial)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2187 26.3826C32.1687 27.1353 29.5093 29.7314 28.5793 29.7314C19.9741 29.7314 18.5773 34.937 18.5773 34.937C18.9583 39.3205 22.0128 42.9309 25.7052 44.8407C25.8739 44.9282 26.0449 45.007 26.2159 45.0843C26.512 45.2155 26.8082 45.3368 27.1044 45.4482C28.3716 45.8967 29.6989 46.1528 31.042 46.2079C46.1247 46.9153 49.0465 28.1714 38.1621 22.7323C40.7298 22.3982 43.3301 23.0296 45.4587 24.504C44.1291 22.1574 42.2018 20.2049 39.8728 18.8448C37.5438 17.4847 34.8962 16.7657 32.1991 16.7607C31.84 16.7607 31.4886 16.7904 31.1357 16.8146C28.1002 17.0233 25.198 18.1419 22.8076 20.0245C23.2691 20.4149 23.7899 20.9365 24.8869 22.0179C26.9404 24.0409 32.2069 26.1366 32.2187 26.3826Z",
    fill: "url(#paint5_radial)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3967 19.0181C21.6419 19.1742 21.8441 19.3101 22.0214 19.4327C21.3318 17.0192 21.3025 14.4649 21.9363 12.0361C19.1449 13.3884 16.6645 15.3054 14.6522 17.6657C14.7997 17.6618 19.1894 17.583 21.3967 19.0181Z",
    fill: "url(#paint6_radial)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M2.18042 32.9177C4.5158 46.7176 17.0227 57.2537 31.2216 57.6558C44.3625 58.0275 52.7577 50.3991 56.226 42.9572C59.1627 36.5255 59.5001 29.2077 57.1676 22.533V22.5041C57.1676 22.4815 57.1629 22.4682 57.1676 22.4752L57.1731 22.526C58.2467 29.5352 54.6816 36.3259 49.1082 40.9178L49.091 40.9568C38.2316 49.801 27.8391 46.2928 25.7357 44.8608C25.5889 44.7906 25.4421 44.7174 25.2953 44.6414C18.9638 41.615 16.3481 35.8465 16.9087 30.8993C15.4057 30.9215 13.9286 30.5073 12.6562 29.707C11.3839 28.9067 10.371 27.7545 9.74015 26.3902C11.4022 25.372 13.2973 24.7963 15.2448 24.7181C17.1924 24.64 19.1275 25.0618 20.8658 25.9435C24.4496 27.5705 28.5276 27.7308 32.228 26.3902C32.2163 26.1442 26.9498 24.0478 24.8963 22.0255C23.7993 20.9441 23.2785 20.4233 22.817 20.0321C22.5676 19.8209 22.307 19.6233 22.0362 19.4402C21.8566 19.3177 21.6544 19.1849 21.4116 19.0256C19.2043 17.5905 14.8146 17.6694 14.6694 17.6733H14.6553C13.456 16.1531 13.5403 11.1403 13.609 10.0933C13.2542 10.2359 12.9155 10.4157 12.5987 10.6297C11.5399 11.3853 10.5502 12.2332 9.64099 13.1634C8.60123 14.2109 7.65105 15.3436 6.80043 16.5497V16.5544V16.5489C4.85486 19.3072 3.47491 22.4235 2.74025 25.7179C2.72542 25.7796 1.65025 30.48 2.18042 32.9177Z",
    fill: "url(#paint7_radial)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8376 20.9762C43.9423 22.0613 44.8886 23.2967 45.6484 24.646C45.8148 24.7717 45.9701 24.8966 46.1021 25.0176C52.963 31.3421 49.3682 40.2823 49.1004 40.9187C54.6737 36.3268 58.2358 29.5361 57.1653 22.5269C53.7422 13.9927 47.9401 10.5533 43.2014 3.0638C42.9617 2.68511 42.722 2.30564 42.4885 1.90509C42.355 1.67632 42.2481 1.47018 42.1551 1.28045C41.9586 0.89985 41.8071 0.49762 41.7038 0.0819175C41.704 0.0627349 41.697 0.0441725 41.6844 0.0297715C41.6717 0.0153705 41.6542 0.00613873 41.6351 0.00383725C41.6165 -0.00127908 41.5968 -0.00127908 41.5781 0.00383725C41.5742 0.00383725 41.568 0.0108645 41.5633 0.0124261C41.5586 0.0139877 41.5485 0.0210149 41.5414 0.0241381C40.371 0.579289 33.4305 11.5691 42.8376 20.9762Z",
    fill: "url(#paint8_radial)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0974 25.0136C45.9655 24.8926 45.8101 24.7677 45.6438 24.642C45.5821 24.5959 45.5212 24.5498 45.4556 24.5038C43.327 23.0294 40.7267 22.398 38.159 22.7321C49.0434 28.1743 46.1232 46.9151 31.0389 46.2077C29.6958 46.1526 28.3685 45.8965 27.1013 45.448C26.8051 45.3371 26.5089 45.2159 26.2127 45.0842C26.0417 45.0061 25.8707 44.928 25.7021 44.8405L25.7232 44.8538C27.8266 46.2897 38.216 49.7979 49.0785 40.9498L49.0957 40.9108C49.3666 40.2783 52.9614 31.3358 46.0974 25.0136Z",
    fill: "url(#paint9_radial)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5773 34.9368C18.5773 34.9368 19.9741 29.7312 28.5793 29.7312C29.5093 29.7312 32.171 27.1351 32.2187 26.3824C28.5182 27.723 24.4402 27.5627 20.8564 25.9358C19.1181 25.054 17.183 24.6322 15.2354 24.7104C13.2879 24.7885 11.3928 25.3642 9.73077 26.3824C10.3616 27.7467 11.3745 28.8989 12.6469 29.6992C13.9192 30.4995 15.3964 30.9137 16.8993 30.8915C16.3387 35.8395 18.9544 41.608 25.2859 44.6336C25.4272 44.7016 25.56 44.775 25.7052 44.8398C22.0097 42.9307 18.9583 39.3203 18.5773 34.9368Z",
    fill: "url(#paint10_radial)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1643 20.9465C58.8495 17.7827 56.1823 14.3667 54.0936 13.2868C55.5834 16.172 56.6172 19.2705 57.1583 22.4722L57.1637 22.523C53.7422 13.9927 47.9401 10.5533 43.2014 3.0638C42.9617 2.68511 42.722 2.30564 42.4885 1.90509C42.355 1.67632 42.2481 1.47018 42.1551 1.28045C41.9586 0.89985 41.8071 0.49762 41.7038 0.0819175C41.704 0.0627349 41.697 0.0441725 41.6844 0.0297715C41.6717 0.0153705 41.6542 0.00613873 41.6351 0.00383725C41.6165 -0.00127908 41.5968 -0.00127908 41.5781 0.00383725C41.5742 0.00383725 41.568 0.0108645 41.5633 0.0124261C41.5586 0.0139877 41.5485 0.0210149 41.5414 0.0241381L41.5531 0.00383725C33.952 4.45441 31.373 12.6934 31.1357 16.8145C31.4886 16.7903 31.8384 16.7606 32.1991 16.7606C34.8962 16.7656 37.5438 17.4846 39.8728 18.8447C42.2018 20.2048 44.1291 22.1573 45.4587 24.5039C43.3301 23.0295 40.7298 22.3981 38.1621 22.7322C49.0465 28.1744 46.1263 46.9152 31.042 46.2078C29.6989 46.1527 28.3716 45.8966 27.1044 45.4481C26.8082 45.3372 26.512 45.2159 26.2158 45.0842C26.0448 45.0062 25.8739 44.9281 25.7052 44.8406L25.7263 44.8539C25.5795 44.7836 25.4327 44.7105 25.2859 44.6345C25.4272 44.7024 25.56 44.7758 25.7052 44.8406C22.0097 42.9308 18.9583 39.3204 18.5773 34.9369C18.5773 34.9369 19.9741 29.7313 28.5793 29.7313C29.5093 29.7313 32.171 27.1352 32.2187 26.3825C32.2069 26.1365 26.9404 24.0401 24.8869 22.0178C23.7899 20.9364 23.2691 20.4156 22.8076 20.0244C22.5583 19.8131 22.2976 19.6156 22.0268 19.4325C21.3373 17.019 21.3079 14.4647 21.9417 12.036C19.1503 13.3883 16.67 15.3052 14.6576 17.6656H14.6436C13.4443 16.1454 13.5286 11.1326 13.5973 10.0856C13.2425 10.2281 12.9038 10.408 12.5869 10.622C11.5282 11.3776 10.5385 12.2255 9.62926 13.1557C8.59322 14.2061 7.64696 15.3415 6.80042 16.5498V16.5545V16.549C4.85485 19.3073 3.4749 22.4236 2.74025 25.718L2.69964 25.9179C2.64265 26.1841 2.38732 27.5365 2.35063 27.8269C2.35063 27.8488 2.35063 27.8043 2.35063 27.8269C2.1171 29.2229 1.96795 30.6317 1.90401 32.0456V32.2018C1.91064 39.7789 4.75942 47.0779 9.88733 52.6562C15.0152 58.2345 22.0492 61.6862 29.599 62.3292C37.1488 62.9722 44.6651 60.7597 50.6625 56.1289C56.6599 51.4981 60.702 44.786 61.9899 37.3192C62.0406 36.9288 62.082 36.5423 62.1273 36.148C62.7506 30.9964 62.0758 25.7708 60.1643 20.9465ZM57.1622 22.5011L57.1676 22.5331L57.1622 22.5011Z",
    fill: "url(#paint11_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 56.1588,
    y1: 9.67329,
    x2: 5.9228,
    y2: 58.1416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.048,
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.111,
    stopColor: "#FFE847"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.225,
    stopColor: "#FFC830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.368,
    stopColor: "#FF980E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.401,
    stopColor: "#FF8B16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.462,
    stopColor: "#FF672A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.534,
    stopColor: "#FF3647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.705,
    stopColor: "#E31587"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(53.8375 6.92948) scale(63.0865)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.129,
    stopColor: "#FFBD4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.186,
    stopColor: "#FFAC31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.247,
    stopColor: "#FF9D17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.283,
    stopColor: "#FF980E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.403,
    stopColor: "#FF563B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.467,
    stopColor: "#FF3750"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#F5156C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.782,
    stopColor: "#EB0878"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#E50080"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.7852 32.7211) scale(63.0865)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#960E18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351,
    stopColor: "#B11927",
    stopOpacity: 0.74
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.435,
    stopColor: "#DB293D",
    stopOpacity: 0.343
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.497,
    stopColor: "#F5334B",
    stopOpacity: 0.094
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FF3750",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.3907 -7.38718) scale(45.7035)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.132,
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.252,
    stopColor: "#FFDC3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.506,
    stopColor: "#FF9D12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526,
    stopColor: "#FF980E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.8072 49.1996) scale(30.0382)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.353,
    stopColor: "#3A8EE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.472,
    stopColor: "#5C79F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.669,
    stopColor: "#9059FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C139E6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.2325 27.551) rotate(-13.5916) scale(15.9261 18.6455)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.206,
    stopColor: "#9059FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.278,
    stopColor: "#8C4FF3",
    stopOpacity: 0.064
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.747,
    stopColor: "#7716A8",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#6E008B",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.9887 4.3485) scale(21.6095)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE226"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FFDB27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.295,
    stopColor: "#FFC82A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.502,
    stopColor: "#FFA930"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.732,
    stopColor: "#FF7E37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792,
    stopColor: "#FF7139"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.9742 -9.3584) scale(92.1979)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.113,
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.456,
    stopColor: "#FF980E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.622,
    stopColor: "#FF5634"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.716,
    stopColor: "#FF3647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#E31587"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(39.2036 -4.23162) rotate(83.976) scale(67.5741 44.3482)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#FFE847"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.168,
    stopColor: "#FFC830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304,
    stopColor: "#FF980E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.356,
    stopColor: "#FF8B16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.455,
    stopColor: "#FF672A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#FF3647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.737,
    stopColor: "#E31587"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.4798 12.3523) scale(57.5607)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.137,
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FF980E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.592,
    stopColor: "#FF5634"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.655,
    stopColor: "#FF3647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#E31587"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.6741 15.7211) scale(62.9998)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.094,
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.231,
    stopColor: "#FFE141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.509,
    stopColor: "#FFAF1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.626,
    stopColor: "#FF980E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 55.5553,
    y1: 9.41407,
    x2: 12.8095,
    y2: 52.1591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.167,
    stopColor: "#FFF44F",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.266,
    stopColor: "#FFF44F",
    stopOpacity: 0.634
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489,
    stopColor: "#FFF44F",
    stopOpacity: 0.217
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FFF44F",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirefox);
export default __webpack_public_path__ + "static/media/firefox.28942822.svg";
export { ForwardRef as ReactComponent };